import { connect } from 'react-redux'
import get from 'lodash/get'

import {
  requestReportData as onRequestReportData,
  setReportDataReady as onSetReportDataReady,
  setReportDataFailure as onSetReportDataFailure,
  setReportParamsReady as onSetReportParamsReady,
  setReportParamsNotReady as onSetReportParamsNotReady,
  setReportDataRequest as onSetReportDataRequest,
  setReportDataNotRequested as onSetReportDataNotRequested
} from '../../actions/reportDataActions'

const mapStateToProps = state => ({
  reportDataState: state.reportData.dataState,
  reportStartDate: get(state, ['reportData', 'startDate'], new Date()),
  reportEndDate: get(state, ['reportData', 'endDate'], new Date()),
  isReportParamsReady: get(state, ['reportData', 'isReportParamsReady'], false),
  isReportDataReady: get(state, ['reportData', 'isReportDataReady'], false)
})

const mapDispatchToProps = {
  onRequestReportData,
  onSetReportDataReady,
  onSetReportDataFailure,
  onSetReportParamsReady,
  onSetReportParamsNotReady,
  onSetReportDataRequest,
  onSetReportDataNotRequested
}

const withReportData = Component => connect(mapStateToProps, mapDispatchToProps)(Component)

export { withReportData }